<template>
    <Upload class="upload" v-show="hasUpload === true">
        <div class="upload-header d-flex">
            <div>
            {{
                getTextUpload(uploadedFiles, countUpload, countUploadError)
            }}
            </div>
            <div class="ml-auto">
            <span
                class="mr-2 cursor-pointer"
                :class="visible ? null : 'collapsed'"
                :aria-expanded="visible ? 'true' : 'false'"
                aria-controls="collapse-upload-list"
                @click="visible = !visible"
            >
                <span v-show="!visible">
                <i class="far fa-chevron-up"></i>
                </span>
                <span v-show="visible">
                <i class="far fa-chevron-down"></i>
                </span>
            </span>
            <span
                class="cursor-pointer pl-gd-half"
                @click="openDialogCancelUpload()"
            >
                <i class="far fa-times"></i>
            </span>
            </div>
        </div>
        <b-collapse
            visible
            class="upload-list"
            id="collapse-upload-list"
            v-model="visible"
        >
            <b-row
                v-for="(file, file_index) in fileUpload"
                :key="`file_preview_${file_index}_${file.name}_${file.status}`"
                class="file-uploading"
                :class="[!file.error ? 'cursor-pointer' : '']"
                @click="file.status === 'done' ? goToFiles(file) : false"
            >
                <b-col cols="2" class="pr-0">
                <div 
                    class="rounded icon-name"
                    style="width: 32px; height: 32px; border: 1px solid lightgray;"                
                    v-show="isDoc(file)" 
                    v-html="genUrlPreview(file, file_index)">
                </div>
                <img
                    v-show="!isDoc(file)"
                    class="rounded"
                    :src="genUrlPreview(file, file_index)"
                    data-holder-rendered="true"
                    style="
                    width: 32px;
                    height: 32px;
                    object-fit: contain;
                    border: 1px solid lightgray;
                    "
                />
                </b-col>
                <b-col cols="9" class="pl-2 pr-0 text-warp lh-1 text-dark">
                <div
                    class="text-truncate"
                    v-b-tooltip.hover
                    :title="file.name"
                >
                    {{ file.name.substr(0, 14) + "..." }}
                    <span class="text-muted">
                    ({{ parseFloat(file.size / 1024).toFixed(2) }} KB)
                    </span>
                </div>
                <small v-if="file.error" class="text-danger">
                    {{ getError(file.error) }}
                </small>
                </b-col>
                <b-col
                cols="1"
                class="px-0 lh-1"
                :class="[file.error ? 'text-danger' : 'text-success']"
                >
                <span v-show="file.error">
                    <i class="fas fa-times-circle"></i>
                </span> 
                <span v-show="!file.error">
                    <span
                    v-if="
                        file.uploadPercentage !== 100 &&
                        file.status !== 'uploaded' && 
                        rerenderProgress
                    "
                    >
                    <vue-ellipse-progress
                        :legend="false"
                        color="#36bee2"
                        animation="default 0 0"
                        :size="20"
                        :progress="file.uploadPercentage"
                    >
                        <div slot="legend-caption">
                        <span
                            class="d-none text-danger"
                            :class="{ times: file.status !== 'uploaded' }"
                            @click="cancelRequest(file_index)"
                        >
                            <i class="far fa-times"></i>
                        </span>
                        </div>
                    </vue-ellipse-progress>
                    </span>
                    <span v-if="file.status == 'uploaded'">
                    <b-spinner
                        small
                        variant="blue"
                        label="Loading..."
                    ></b-spinner>
                    </span>
                    <span
                    :class="{ check: file.status === 'done' }"
                    v-show="file.status === 'done'"
                    >
                    <span>
                        <i class="fas fa-check-circle"></i>
                    </span>
                    </span>
                    <span
                    class="d-none"
                    :class="{ chevron: file.status === 'done' }"
                    v-show="file.status === 'done'"
                    >
                    <span>
                        <i class="fas fa-chevron-circle-right"></i>
                    </span>
                    </span>
                </span>
                </b-col>
            </b-row>
            <div v-if="fileUpload.length === 0" class="text-muted">
            List upload is empty.
            </div>
        </b-collapse>
    </Upload>
</template>

<script>
import {
  Upload,
} from "./Filemanager.styled";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            visible : true,
            limitSizeFile : 4,//MB
            limitItemFile : 20,
            limitSizeDoc : 50,//MB
            limitItemDoc : 10,
            temp : '',
        }
    },
    components :{
        Upload
    },
    computed:{
        ...mapGetters({
            languageEngine: "design/userPreference/languageEngine",
        }),
        whitelistFile() {
            const img = "JPG, JPEG ,PNG, GIF or WEBP";
            const doc = "DOC, XLS, TXT, PDF or PPT";
            return this.selectDirectoryID === "document" ? doc : img;
        },
    },
    methods: {
        getTextUpload(uploadedFiles, countUpload, countUploadError) {
            let text = "";
            if (countUploadError > 0 && countUploadError == countUpload) {
                text =
                this.$t('engine.filemanager.uploadAlert.uploadFail', this.languageEngine, {countUploadError:countUploadError})
                +
                (this.languageEngine === 'th' ? ''
                    :countUploadError > 1 ? 's.' : '.'
                );
            } else if (
                countUploadError > 0 &&
                Math.abs(countUploadError - countUpload) == uploadedFiles
            ) {
                text =
                this.$t(
                    'engine.filemanager.uploadAlert.uploaded', 
                    this.languageEngine, 
                    {uploadedFiles:uploadedFiles,countUpload:countUpload}
                )
                +
                (this.languageEngine === 'th' ? ''
                    :countUpload > 1 ? 's.' : '.'
                );
            } else if (uploadedFiles != countUpload) {
                text =
                this.$t(
                    'engine.filemanager.uploadAlert.uploading', 
                    this.languageEngine,
                    {uploadedFiles: uploadedFiles, countUpload: countUpload}
                )
                +
                (this.languageEngine === 'th' ? ''
                    :countUpload > 1 ? 's.' : '.'
                );
            } else {
                text = uploadedFiles + ' ' + this.$t('engine.common.alert.success.title', this.languageEngine);
            }
            return text;
        },
        async goToFiles(file) {
            this.$emit('goToFiles',file);
        },
        cancelRequest(index) {
            this.$emit('cancelRequest',index);
        },
        genUrlPreview(file,file_index) {
            const arrName = file.name.split(".");
            const url = this.documentIcon(arrName.pop());
            if (url !== "") {
                return url;
            }
            const file_data = new File([file], file.name, { type: file.type });
            const vm = this;
            let reader = new FileReader();
            reader.readAsDataURL(file_data); 
            reader.onloadend = function () {
                vm.fileUpload[file_index].preview = reader.result;        
            }
            return this.fileUpload[file_index].preview;
        },
        documentIcon(type) {
            let url = "";
            const doc = "pdf, ppt, pptx, doc ,docx, xls,xlsx,txt";
            if (doc.toLowerCase().search(type.toLowerCase()) != -1) {
                switch (type.toLowerCase()) {
                case "pdf":
                    url = `<span class="pdf icon-name"><i class="fas fa-file-pdf"></i><span>`;
                    break;
                case "ppt":
                case "pptx":
                    url =
                    `<span class="powerpoint icon-name"><i class="fas fa-file-powerpoint"></i><span>`;
                    break;
                case "doc":
                case "docx":
                    url = `<span class="word icon-name"><i class="fas fa-file-word"></i><span>`;
                    break;
                case "xls":
                case "xlsx":
                    url = `<span class="excel icon-name"><i class="fas fa-file-excel"></i><span>`;
                    break;
                default:
                    url = `<span class="txt icon-name"><i class="fas fa-file-alt"></i><span>`;
                }
            }
            return url;
        },
        openDialogCancelUpload() {
            if(this.uploadedFiles < (Math.abs(this.countUpload - this.countUploadError))) {
                this.$bvModal.show("modal-confirm-cancel");
            }else {
                this.$emit('hasUpload',false);
                (this.visible = true)
            }
        },
        getError(error) {
            let text = "";
            const limitSize = this.selectDirectoryID === "document" ? this.limitSizeDoc : this.limitSizeFile;
            const limit = this.selectDirectoryID === "document" ? this.limitItemDoc : this.limitItemFile;

            switch (error) {
                case "ERROR_FILES_TYPE":
                text = `Only "${this.whitelistFile}" files are supported.`;
                break;
                case "ERROR_FILES_SIZE":
                text = `Maximum upload file size ${limitSize} MB.`;
                break;
                case "ERROR_UPLOAD_CANCEL":
                text = `Cancel upload this file.`;
                break;
                default:
                text = `System Limit on number of files to upload ${limit} files per time.`;
                break;
            }
            return text;
        },
        isDoc(file) {
            const img = "image/jpg, image/jpeg, image/png, image/gif, image/webp";
            if (img.search(file.type) != -1) {
                return false;
            } else {
                return true;
            }
        },
    },
    props :  {
        hasUpload: {
            type : Boolean,
            default : false
        },
        rerenderProgress: {
            type : Boolean,
            default : false
        },
        uploadedFiles : {
            type : Number,
            default : 0
        },
        countUpload : {
            type : Number,
            default : 0
        },
        countUploadError : {
            type : Number,
            default : 0
        },
        fileUpload : {
            type : Array,
            default: () => []
        },
        selectDirectoryID :{

        }
    }
}
</script>

<style>
.icon-name {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.pdf {
  color : #E13022;
}
.word {
  color : #3BA9FF;
}
.powerpoint {
  color : #F89605;
}
.excel {
  color : #429600;
}
.txt {
  color : #373E44;
}
</style>